/**
 * Oduree: venster voor land, munt en taal (snippets/oduree-locatiekiezer.liquid).
 * - Landen en hun munt: de wereldwijde markt in Shopify (Markets, eigen munt per land). Namen in de taal
 *   van de pagina via Intl.DisplayNames, zodat de lijst op oduree.nl net zo compleet is als op oduree.com.
 * - Bevestigen: window.OdureeLocatie.kies(land, taal) uit oduree-localization.js.
 * Bijwerken van LANDEN: alleen als landen of munten in Shopify Markets veranderen.
 */
(function () {
  'use strict';

  var LANDEN = {"NL":"EUR","BE":"EUR","DE":"EUR","AT":"EUR","US":"USD","AX":"EUR","AL":"ALL","AD":"EUR","BY":"EUR","BA":"BAM","BG":"EUR","DK":"DKK","IM":"GBP","EE":"EUR","FO":"DKK","FI":"EUR","FR":"EUR","GI":"GBP","GR":"EUR","GG":"GBP","HU":"HUF","IE":"EUR","IS":"ISK","IT":"EUR","JE":"EUR","XK":"EUR","HR":"EUR","LV":"EUR","LI":"CHF","LT":"EUR","LU":"EUR","MK":"MKD","MT":"EUR","MD":"MDL","MC":"EUR","ME":"EUR","NO":"EUR","UA":"UAH","PL":"PLN","PT":"EUR","RO":"RON","RU":"EUR","SM":"EUR","RS":"RSD","SI":"EUR","SK":"EUR","ES":"EUR","SJ":"EUR","CZ":"CZK","VA":"EUR","GB":"GBP","SE":"SEK","CH":"CHF","AF":"AFN","DZ":"DZD","AO":"EUR","AI":"XCD","AG":"XCD","AR":"EUR","AM":"AMD","AW":"AWG","AC":"SHP","AU":"AUD","AZ":"AZN","BS":"BSD","BH":"EUR","BD":"BDT","BB":"BBD","BZ":"BZD","BJ":"XOF","BM":"USD","BT":"EUR","BO":"BOB","BW":"BWP","BR":"EUR","IO":"USD","VG":"USD","BN":"BND","BF":"XOF","BI":"BIF","KH":"KHR","CA":"CAD","BQ":"USD","CF":"XAF","CL":"EUR","CN":"CNY","CX":"AUD","CC":"AUD","CO":"EUR","KM":"KMF","CG":"XAF","CD":"CDF","CK":"NZD","CR":"CRC","CW":"ANG","CY":"EUR","DJ":"DJF","DM":"XCD","DO":"DOP","EC":"USD","EG":"EGP","SV":"USD","GQ":"XAF","ER":"EUR","SZ":"EUR","ET":"ETB","FK":"FKP","FJ":"FJD","PH":"PHP","GF":"EUR","PF":"XPF","TF":"EUR","GA":"XOF","GM":"GMD","GE":"EUR","GH":"EUR","GD":"XCD","GL":"DKK","GP":"EUR","GT":"GTQ","GN":"GNF","GW":"XOF","GY":"GYD","HT":"EUR","HN":"HNL","HK":"HKD","IN":"INR","ID":"IDR","IQ":"EUR","IL":"ILS","CI":"XOF","JM":"JMD","JP":"JPY","YE":"YER","JO":"EUR","KY":"KYD","CV":"CVE","CM":"XAF","KZ":"KZT","KE":"KES","KG":"KGS","KI":"EUR","UM":"USD","KW":"EUR","LA":"LAK","LS":"EUR","LB":"LBP","LR":"EUR","LY":"EUR","MO":"MOP","MG":"EUR","MW":"MWK","MV":"MVR","MY":"MYR","ML":"XOF","MA":"MAD","MQ":"EUR","MR":"EUR","MU":"MUR","YT":"EUR","MX":"EUR","MN":"MNT","MS":"XCD","MZ":"EUR","MM":"MMK","NA":"EUR","NR":"AUD","NP":"NPR","NI":"NIO","NC":"XPF","NZ":"NZD","NE":"XOF","NG":"NGN","NU":"NZD","NF":"AUD","UG":"UGX","UZ":"UZS","OM":"EUR","TL":"USD","PK":"PKR","PS":"ILS","PA":"USD","PG":"PGK","PY":"PYG","PE":"PEN","PN":"NZD","QA":"QAR","RE":"EUR","RW":"RWF","KN":"XCD","LC":"XCD","VC":"XCD","BL":"EUR","MF":"EUR","PM":"EUR","SB":"SBD","WS":"WST","ST":"STD","SA":"SAR","SN":"XOF","SC":"EUR","SL":"SLL","SG":"SGD","SH":"SHP","SX":"ANG","SD":"EUR","SO":"EUR","LK":"LKR","SR":"EUR","TJ":"TJS","TW":"TWD","TZ":"TZS","TH":"THB","TG":"XOF","TK":"NZD","TO":"TOP","TT":"TTD","TA":"GBP","TD":"XAF","TN":"EUR","TR":"EUR","TM":"EUR","TC":"USD","TV":"AUD","UY":"UYU","VU":"VUV","VE":"USD","AE":"AED","VN":"VND","WF":"XPF","EH":"MAD","ZM":"EUR","ZW":"USD","ZA":"EUR","GS":"GBP","KR":"KRW","SS":"EUR"};
  /* Taalnamen in hun eigen taal, zoals gebruikelijk in een taalkiezer. */
  var TAALNAAM = {
    nl: 'Nederlands', en: 'English', de: 'Deutsch', fr: 'Français', es: 'Español', it: 'Italiano',
    'pt-PT': 'Português', pl: 'Polski', sv: 'Svenska', da: 'Dansk', nb: 'Norsk', fi: 'Suomi',
    cs: 'Čeština', hu: 'Magyar', ro: 'Română', el: 'Ελληνικά', ar: 'العربية'
  };

  var dlg = document.getElementById('odu-locatie');
  if (!dlg || typeof dlg.showModal !== 'function') return;
  var cfg;
  try { cfg = JSON.parse(dlg.querySelector('[data-odu-lk-config]').textContent); } catch (e) { return; }

  var paginaTaal = document.documentElement.lang || 'en';
  /* Landnamen in de taal van de pagina (op /de 'Deutschland', op oduree.nl 'Duitsland'), met subtiel de eigen naam
     van het land erachter als die anders is: de hoofdtaal van het land komt uit Intl.Locale (bijv. und-AT -> de), de
     naam uit Intl.DisplayNames. Zoeken kan op de naam in de paginataal, de Engelse naam, de eigen naam, code en munt. */
  var maakNamen = function (taal) {
    try { return new Intl.DisplayNames([taal], { type: 'region' }); } catch (e) { return null; }
  };
  var namen = maakNamen(paginaTaal) || maakNamen('en');
  var engelseNamen = maakNamen('en');
  var naamUit = function (lijst, code) {
    try { var n = lijst && lijst.of(code); return n && n !== code ? n : ''; } catch (e) { return ''; }
  };
  var landNaam = function (code) { return naamUit(namen, code) || naamUit(engelseNamen, code) || code; };
  /* Zoeken zonder hoofdletters en accenten: 'belgie' vindt België, 'osterreich' vindt Österreich. */
  var plat = function (s) {
    s = String(s || '').toLowerCase();
    try { return s.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (e) { return s; }
  };
  var eigenNaam = function (code, naam) {
    try {
      var taal = new Intl.Locale('und-' + code).maximize().language;
      if (!taal || taal === 'und') return '';
      var n = new Intl.DisplayNames([taal + '-' + code], { type: 'region' }).of(code);
      return n && n !== naam && n !== code ? n : '';
    } catch (e) { return ''; }
  };
  var symbool = function (munt) {
    try {
      var p = new Intl.NumberFormat(paginaTaal, { style: 'currency', currency: munt, currencyDisplay: 'narrowSymbol' })
        .formatToParts(0).filter(function (x) { return x.type === 'currency'; })[0];
      return p && p.value !== munt ? p.value : '';
    } catch (e) { return ''; }
  };
  var vlag = function (code) {
    var img = document.createElement('img');
    img.className = 'odu-lk-vlag';
    img.src = 'https://cdn.shopify.com/static/images/flags/' + code.toLowerCase() + '.svg';
    img.alt = ''; img.width = 20; img.height = 20; img.loading = 'lazy'; img.decoding = 'async';
    return img;
  };

  /* Kleine overzeese gebieden en onbewoonde eilanden niet in de lijst (op verzoek van Oduree; ze blijven wel
     in de Shopify-markt, dus een bezoeker van daar kan gewoon bestellen). */
  var NIET_TONEN = ['UM', 'WF', 'MF', 'PM', 'BL', 'GS', 'AC', 'TA', 'SJ', 'TF', 'IO', 'PN', 'TK', 'NU', 'NF', 'CX', 'CC', 'SH', 'FK'];
  NIET_TONEN.forEach(function (code) { if (code !== cfg.land) delete LANDEN[code]; });

  /* Het huidige land altijd in de lijst, ook als het (nog) niet in de vaste lijst staat. */
  /* Nederland of België gekozen en in een andere taal op oduree.com: Shopify zegt Ierland, wij tonen het gekozen land. */
  var echtLand = cfg.land;
  if (window.OdureeLocatie && window.OdureeLocatie.weergaveLand) cfg.land = window.OdureeLocatie.weergaveLand(cfg.land) || cfg.land;
  if (cfg.land !== echtLand) {
    document.querySelectorAll('.odu-lk-knop').forEach(function (b) {
      var img = b.querySelector('.odu-lk-vlag');
      if (img) img.src = 'https://cdn.shopify.com/static/images/flags/' + cfg.land.toLowerCase() + '.svg';
      var sp = b.querySelector('span');
      if (sp && sp.textContent.indexOf(echtLand) === 0) sp.textContent = cfg.land + sp.textContent.slice(echtLand.length);
    });
  }
  if (cfg.land && !LANDEN[cfg.land]) LANDEN[cfg.land] = '';
  var landen = Object.keys(LANDEN).map(function (code) {
    var munt = LANDEN[code];
    var s = munt ? symbool(munt) : '';
    var naam = landNaam(code);
    var engels = naamUit(engelseNamen, code);
    var eigen = eigenNaam(code, naam);
    /* begin: namen waarmee een zoekterm vooraan mag matchen (zie filter). */
    var begin = [naam, engels, eigen].filter(Boolean).map(plat);
    return { code: code, naam: naam, eigen: eigen, begin: begin, label: naam + (munt ? ' (' + munt + (s ? ' ' + s : '') + ')' : ''), zoek: plat(naam + ' ' + engels + ' ' + eigen + ' ' + code + ' ' + munt + ' ' + s) };
  }).sort(function (a, b) { return a.naam.localeCompare(b.naam, paginaTaal); });

  var keuze = { land: cfg.land, taal: cfg.taal };

  /* ---------- Keuzelijsten (combobox met listbox) ---------- */
  function maakKeuze(box, opties, render, gekozen, opKies) {
    var knop = box.querySelector('.odu-lk__waarde');
    var lijst = box.querySelector('.odu-lk__lijst');
    var ul = box.querySelector('.odu-lk__opties');
    var zoek = box.querySelector('input[type="search"]');
    var leeg = box.querySelector('.odu-lk__leeg');
    var items = [];
    var actief = -1;

    opties.forEach(function (o, i) {
      var li = document.createElement('li');
      li.id = ul.id + '-' + i;
      li.setAttribute('role', 'option');
      li.className = 'odu-lk__optie';
      li.dataset.waarde = o.code;
      render(li, o);
      li.addEventListener('click', function () { kies(o); });
      li.addEventListener('mousemove', function () { zetActief(items.indexOf(li)); });
      ul.appendChild(li);
      items.push(li);
    });

    function zichtbaar() { return Array.prototype.filter.call(ul.children, function (li) { return !li.hidden; }); }
    function zetActief(i) {
      items.forEach(function (li) { li.classList.remove('is-actief'); });
      actief = i;
      if (i < 0 || !items[i]) { (zoek || knop).removeAttribute('aria-activedescendant'); return; }
      items[i].classList.add('is-actief');
      (zoek || ul).setAttribute('aria-activedescendant', items[i].id);
      items[i].scrollIntoView({ block: 'nearest' });
    }
    function markeer() {
      items.forEach(function (li) { li.setAttribute('aria-selected', li.dataset.waarde === gekozen() ? 'true' : 'false'); });
    }
    function open() {
      sluitAlles(box);
      lijst.hidden = false;
      knop.setAttribute('aria-expanded', 'true');
      markeer();
      if (zoek) { zoek.value = ''; filter(); zoek.focus(); } else { ul.tabIndex = -1; ul.focus(); }
      var i = items.findIndex(function (li) { return li.dataset.waarde === gekozen(); });
      zetActief(i);
    }
    function dicht(focusKnop) {
      if (lijst.hidden) return;
      lijst.hidden = true;
      knop.setAttribute('aria-expanded', 'false');
      if (focusKnop) knop.focus();
    }
    function kies(o) { opKies(o); markeer(); dicht(true); }
    function filter() {
      var q = plat((zoek.value || '').trim());
      opties.forEach(function (o, i) { items[i].hidden = !!q && o.zoek.indexOf(q) === -1; });
      /* Landen waarvan een naam met de zoekterm begint, komen bovenaan ("netherlands" vóór "Caribbean Netherlands",
         op /de ook "germ" -> Deutschland). */
      var begin = [], rest = [];
      var vooraan = function (o) { return (o.begin || [plat(o.naam)]).some(function (n) { return n.indexOf(q) === 0; }); };
      opties.forEach(function (o, i) { if (!items[i].hidden) ((q && vooraan(o)) ? begin : rest).push(items[i]); });
      begin.concat(rest).forEach(function (li) { ul.appendChild(li); });
      var z = zichtbaar();
      if (leeg) leeg.hidden = z.length > 0;
      zetActief(z.length ? items.indexOf(z[0]) : -1);
    }
    function toets(e) {
      var z = zichtbaar(); var pos = z.indexOf(items[actief]);
      if (e.key === 'ArrowDown') { e.preventDefault(); zetActief(items.indexOf(z[Math.min(z.length - 1, pos + 1)])); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); zetActief(items.indexOf(z[Math.max(0, pos - 1)])); }
      else if (e.key === 'Enter') { e.preventDefault(); if (items[actief] && !items[actief].hidden) kies(opties[actief]); }
      else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); dicht(true); }
      else if (e.key === 'Tab') { dicht(false); }
    }

    knop.addEventListener('click', function () { lijst.hidden ? open() : dicht(true); });
    if (zoek) { zoek.addEventListener('input', filter); zoek.addEventListener('keydown', toets); }
    else ul.addEventListener('keydown', toets);
    box._dicht = dicht;
    markeer();
  }

  function sluitAlles(behalve) {
    dlg.querySelectorAll('[data-odu-lk-keuze]').forEach(function (b) { if (b !== behalve && b._dicht) b._dicht(false); });
  }

  maakKeuze(dlg.querySelector('[data-odu-lk-keuze="land"]'), landen, function (li, o) {
    li.appendChild(vlag(o.code));
    var s = document.createElement('span'); s.className = 'odu-lk__naam'; s.textContent = o.label; li.appendChild(s);
    if (o.eigen) {
      var e = document.createElement('span'); e.className = 'odu-lk__eigen'; e.textContent = o.eigen;
      e.lang = new Intl.Locale('und-' + o.code).maximize().language;
      li.appendChild(e);
    }
  }, function () { return keuze.land; }, function (o) {
    keuze.land = o.code;
    /* Taal springt mee naar de taal van het land; bestaat die (nog) niet, dan Engels. */
    var t = window.OdureeLocatie && window.OdureeLocatie.taalVoorLand ? window.OdureeLocatie.taalVoorLand(o.code) : 'en';
    var match = (cfg.talen || []).filter(function (c) { return c.toLowerCase() === String(t).toLowerCase(); })[0]
      || ((cfg.talen || []).indexOf('en') !== -1 ? 'en' : keuze.taal);
    if (match && match !== keuze.taal) {
      keuze.taal = match;
      var tw = dlg.querySelector('#odu-lk-taal-waarde');
      tw.textContent = TAALNAAM[match] || match; tw.lang = match;
      var tb = dlg.querySelector('[data-odu-lk-keuze="taal"]');
      tb.querySelectorAll('.odu-lk__optie').forEach(function (li) { li.setAttribute('aria-selected', li.dataset.waarde === match ? 'true' : 'false'); });
    }
    var w = dlg.querySelector('#odu-lk-land-waarde');
    w.textContent = o.label;
    var img = w.parentNode.querySelector('.odu-lk-vlag');
    if (img) img.src = 'https://cdn.shopify.com/static/images/flags/' + o.code.toLowerCase() + '.svg';
  });

  var talen = (cfg.talen || []).map(function (code) { return { code: code, naam: TAALNAAM[code] || code }; });
  maakKeuze(dlg.querySelector('[data-odu-lk-keuze="taal"]'), talen, function (li, o) {
    li.lang = o.code;
    li.textContent = o.naam;
  }, function () { return keuze.taal; }, function (o) {
    keuze.taal = o.code;
    var w = dlg.querySelector('#odu-lk-taal-waarde');
    w.textContent = o.naam; w.lang = o.code;
  });
  /* Toon de gekozen taal met de eigen naam, net als in de lijst. */
  (function () {
    var w = dlg.querySelector('#odu-lk-taal-waarde');
    if (TAALNAAM[cfg.taal]) w.textContent = TAALNAAM[cfg.taal];
    var huidig = landen.filter(function (l) { return l.code === cfg.land; })[0];
    if (huidig) {
      var lw = dlg.querySelector('#odu-lk-land-waarde');
      lw.textContent = huidig.label;
      var lv = lw.parentNode.querySelector('.odu-lk-vlag');
      if (lv) lv.src = 'https://cdn.shopify.com/static/images/flags/' + huidig.code.toLowerCase() + '.svg';
    }
  })();

  /* ---------- Venster ---------- */
  /* Staat de knop in een open lade van het thema (het zijmenu #sidebar-menu op mobiel), dan eerst die lade sluiten.
     De lade houdt de focus vast en vangt een tik daarbuiten af: zonder dit sloot de eerste tik in het venster alleen
     het menu erachter en opende de keuzelijst pas bij de tweede tik. hide() zet de focusval meteen uit. */
  function sluitLadeRond(opener) {
    for (var el = opener && opener.parentElement; el; el = el.parentElement) {
      if (el !== dlg && el.hasAttribute('open') && typeof el.hide === 'function') {
        try { el.hide(); } catch (e) { el.removeAttribute('open'); }
      }
    }
  }
  function openVenster(opener) {
    if (dlg.open) return;
    sluitLadeRond(opener);
    var html = document.documentElement;
    /* Oudere browsers zonder scrollbar-gutter: de breedte van de schuifbalk zelf opvangen. */
    var balk = window.innerWidth - html.clientWidth;
    if (balk > 0 && !(window.CSS && CSS.supports && CSS.supports('scrollbar-gutter', 'stable'))) {
      html.style.setProperty('--odu-lk-balk', balk + 'px');
      html.classList.add('odu-lk-compenseer');
    }
    dlg.showModal();
    html.classList.add('odu-lk-open');
  }
  function sluitVenster() { if (dlg.open) dlg.close(); }
  dlg.addEventListener('close', function () { sluitAlles(null); document.documentElement.classList.remove('odu-lk-open', 'odu-lk-compenseer'); });
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-odu-locatie-open]');
    if (t) { e.preventDefault(); openVenster(t); }
  });
  dlg.querySelector('[data-odu-locatie-sluit]').addEventListener('click', sluitVenster);
  /* Klik naast het paneel (op de achtergrond) sluit. */
  dlg.addEventListener('click', function (e) { if (e.target === dlg) sluitVenster(); });
  /* Klik buiten een open lijst binnen het paneel sluit die lijst. */
  dlg.addEventListener('pointerdown', function (e) {
    if (!e.target.closest('[data-odu-lk-keuze]')) sluitAlles(null);
  });

  dlg.querySelector('[data-odu-locatie-bevestig]').addEventListener('click', function () {
    if (keuze.land === cfg.land && keuze.taal === cfg.taal) { sluitVenster(); return; }
    if (window.OdureeLocatie && typeof window.OdureeLocatie.kies === 'function') {
      this.disabled = true;
      window.OdureeLocatie.kies(keuze.land, keuze.taal);
    }
  });
})();
